import { render, staticRenderFns } from "./tabLocalService.vue?vue&type=template&id=28a421a0&scoped=true&"
import script from "./tabLocalService.vue?vue&type=script&lang=js&"
export * from "./tabLocalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a421a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a421a0')) {
      api.createRecord('28a421a0', component.options)
    } else {
      api.reload('28a421a0', component.options)
    }
    module.hot.accept("./tabLocalService.vue?vue&type=template&id=28a421a0&scoped=true&", function () {
      api.rerender('28a421a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabLocalService.vue"
export default component.exports